<!--<ng-container *ngIf="isMenuLinkBox; else MenuPanel">
  <div class="widget no-shadow border-less">
    <div class="widget-header">
      <div class="widget-header-section title">
        <h2>{{ panelTitle }}</h2>
      </div>
    </div>
    <div class="widget-content">
      <ng-container *ngFor="let link of links">
        <div class="link" [ngClass]="[link.width === 'double' ? 'dual' : 'single']" tabindex="0" (click)="onLinkClicked(link)">
          <div class="status">
            <ng-container *ngIf="link.menu.hasIcon">
              <svg soho-icon icon="{{link.menu.icon}}"/>
            </ng-container>
            <ng-container *ngIf="link.menu.image">
              <img class="avatar" src="{{link.menu.image}}" alt=""/>
            </ng-container>
          </div>
          <div class="text">
            <div class="title">
              {{ link.title }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
<ng-template #MenuPanel>-->
  <lm-form
      *ngIf="formSpec && m_messageRuleView"
      [formUrlInfo]="formUrlInfo"
      [formSpec]="formSpec"
      [initDataView]="m_messageRuleView"
      (formRendered)="onFormRendered($event)"
  ></lm-form>
<!--</ng-template>
<div #menuFormDialog>
  &lt;!&ndash; dialog placeholder used to display action form from menu &ndash;&gt;
</div>-->
